import { render, staticRenderFns } from "./PlateMap.vue?vue&type=template&id=c561fe90&scoped=true&"
import script from "./PlateMap.vue?vue&type=script&lang=js&"
export * from "./PlateMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561fe90",
  null
  
)

export default component.exports